import Select from 'react-select';
import { Box } from '@mui/material';
import { Controller } from 'react-hook-form';
import CustomLabel from 'components/customLabel';

type Props = {
  value?: any;
  errors: any;
  control: any;
  search?: any;
  isMulti: any;
  name: string;
  label: string;
  onChange?: any;
  required?: boolean;
  options?: Object[];
  loading?: boolean;
  isSearchable?: boolean;
  closeMenuOnSelect?: any;
  setSearch?: (e: any) => void;
};

export default function ReactSelectService({
  name,
  value,
  label,
  search,
  errors,
  control,
  options,
  loading,
  isMulti,
  onChange,
  setSearch,
  required = false,
  isSearchable = true,
  closeMenuOnSelect = false,
}: Props) {
  const colourStyles = {
    control: (provided: any) => ({
      ...provided,
      border: errors?.diseases ? '1px solid #D32F2F' : '1px solid #C4c4c4',
    }),
    multiValue: (styles: any) => {
      return {
        ...styles,
        padding: '5px',
        display: 'flex',
        margin: '4px 4px',
        borderRadius: '5px',
        alignItems: 'center',
        backgroundColor: '#F3F8FC',
        border: '1px solid #187CD3',
      };
    },
    multiValueLabel: (styles: any) => ({
      ...styles,
      color: '#187CD3',
      fontSize: '12px',
      lineHeight: '14px',
    }),
    multiValueRemove: (styles: any) => ({
      ...styles,
      padding: 0,
      width: '16px',
      height: '16px',
      color: '#187CD3',
      marginLeft: '5px',
      alignItem: 'center',
      borderRadius: '50px',
      background: '#F3F8FC',
      justfyContent: 'center',
      border: '1px solid #187CD3',

      ':hover': {
        borderRadius: '50px',
        background: '#F3F8FC',
        border: '1px solid #187CD3',
      },
    }),
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Escape') {
      return;
    }
  };

  const handeleSearch = (e: any, value: any) => {
    if (value.action !== 'input-change') {
      return;
    }

    setSearch?.({ ...(search || {}), name: e });
  };

  return (
    <Box mt='15px' mb='20px' width='100%'>
      <CustomLabel>{label}</CustomLabel>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required,
        }}
        render={({ field }) => (
          <Select
            {...field}
            placeholder=''
            options={options}
            isLoading={loading}
            menuPosition='fixed'
            styles={colourStyles}
            onKeyDown={handleKeyDown}
            isSearchable={isSearchable}
            value={field.value || value}
            isMulti={isMulti ? true : false}
            onInputChange={isSearchable ? handeleSearch : undefined}
            closeMenuOnSelect={closeMenuOnSelect}
            onChange={(event: any) => {
              onChange(event);
            }}
          />
        )}
      />
      {errors?.diseases?.type === 'required' && (
        <small style={{ color: 'red' }}>{name} is required</small>
      )}
    </Box>
  );
}
